import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { endPoint } from "constants/server/api";
import { createFetchLogicPrototype } from "../../utils/fetchFactory";
import { createSlicePrototype } from "../../utils/sliceFactory";
import { http } from "utils/http";
var getNewReceiptByIdSlice = createSlicePrototype({
    name: "getNewReceiptById"
});
export var getNewReceiptById = createFetchLogicPrototype({
    actions: getNewReceiptByIdSlice.actions,
    configFn: function(param, param1) {
        var id = param.id, accessToken = param1.accessToken;
        return {
            method: "get",
            url: "".concat(endPoint.NEW_RECEIPT, "/find-by-id/").concat(id),
            headers: {
                Authorization: "Bearer ".concat(accessToken)
            }
        };
    },
    onError: function(error, param) {
        var modalObj = param.modalObj, setModalObj = param.setModalObj;
        var getStatus = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.status : 500;
        };
        var getMessage = function(err) {
            return http.isAxiosError(err) && err.response ? err.response.data.message : "เกิดข้อผิดพลาด\nหรือเครือข่ายขัดข้อง";
        };
        setModalObj === null || setModalObj === void 0 ? void 0 : setModalObj(_object_spread_props(_object_spread({}, modalObj), {
            visible: true,
            subTitle: "รหัส ".concat(getStatus(error)),
            navigateDirection: undefined,
            title: getMessage(error)
        }));
    }
});
export var clearGetNewReceiptById = function() {
    return function(dispatch) {
        dispatch(getNewReceiptByIdSlice.actions.resetState());
    };
};
var _getNewReceiptByIdSlice_actions = getNewReceiptByIdSlice.actions;
export var fetchData = _getNewReceiptByIdSlice_actions.fetchData, fetchDataSuccess = _getNewReceiptByIdSlice_actions.fetchDataSuccess, fetchDataFailure = _getNewReceiptByIdSlice_actions.fetchDataFailure, resetState = _getNewReceiptByIdSlice_actions.resetState;
export default getNewReceiptByIdSlice.reducer;
